import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import times from 'lodash/times';
import { formatPrismicImage } from '~/helpers/image-helper';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/arrow-left-bottom.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/line-vertical.svg';

var GlobalRichText = function GlobalRichText() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/atoms/Editorial/Global/GlobalRichText.vue');
};

export default {
  components: {
    GlobalRichText: GlobalRichText
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentPayload: function currentPayload() {
      var _this = this;

      return {
        images: times(this.payload.items.length, Number).map(function (i) {
          return {
            image: "".concat(formatPrismicImage(_this.payload.items[i].image.url, ['w_375']), " 375w, ").concat(formatPrismicImage(_this.payload.items[i].image.url, ['w_375', 'dpr_2']), " 750w, ").concat(formatPrismicImage(_this.payload.items[i].image.url, ['w_1440']), " 1440w, ").concat(formatPrismicImage(_this.payload.items[i].image.url, ['w_1440', 'dpr_2']), " 2880w")
          };
        }),
        tracking: times(this.payload.items.length, Number).map(function (i) {
          return {
            data: {
              event_category: _this.payload.items[i].event_category || '',
              event_action: _this.payload.items[i].event_action || '',
              event_label: _this.payload.items[i].event_label || ''
            }
          };
        })
      };
    }
  }
};